export default __webpack_public_path__ + "static/media/art-pro-red-poster-2.3bb6cf94.jpg";